<sc-master-detail (deleteEntry)="true" [data]="truckGroups" [selection]="[currentTruckGroup]"
  (selectionChanged)="changeSelection($event)" (deleteEntry)="onDelete($event)" (addEntry)="addEntry($event)">
  <sc-no-data-container fitHeight [hasData]="currentTruckGroup != null">
    @if (currentTruckGroup != null) {
      <sc-padding fitHeight>
        <sc-flex vertical fitHeight stretchContent>
          <div [formGroup]="formGroup" noFieldSpace>
            <sc-string-field labelDictionaryKey="tmc-yard.admin.ui.truck-group.name" formControlName="name">
            </sc-string-field>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-number-field labelDictionaryKey="tmc-yard.admin.ui.truck-group.priority" formControlName="priority">
            </sc-number-field>
          </div>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex-fitting-content vertical>
            <sc-tab-group>
              <sc-tab titleDictionaryKey="tmc-yard.admin.ui.truck-group.trucks">
                <app-trucks [currentTruckGroup]="currentTruckGroup" (trucksChanged)="onTruckChanged($event)"></app-trucks>
              </sc-tab>
              <sc-tab titleDictionaryKey="tmc-yard.admin.ui.truck-group.conditions">
                <sc-flex-fitting-content vertical>
                  <app-truck-group-conditions [currentTruckGroup]="currentTruckGroup"
                  (truckGroupChanged)="onTruckGroupChanged($event)"></app-truck-group-conditions>
                </sc-flex-fitting-content>
              </sc-tab>
            </sc-tab-group>
          </sc-flex-fitting-content>
        </sc-flex>
      </sc-padding>
    }

    <ng-template masterDetailToolbar>
      <sc-save-button [disabled]="!formGroup.dirty && !truckChanged && !truckGroupChanged"
      (click)="onSave()"></sc-save-button>
    </ng-template>
  </sc-no-data-container>
</sc-master-detail>
